// import { useContext, } from "react";

import { useDatastoreStore } from "hooks/datastores/useDatastoresStore";
import { useEffectOnce } from "usehooks-ts";
// import { DemoContext } from "contexts/demo";
// import response from "./response.json";

export const useDatasets = (databaseId: string) => {
  // const { isDemo } = useContext(DemoContext);

  const isLoading = useDatastoreStore((s) => s.loadingDatasets);
  const datasets = useDatastoreStore((s) => s.datasetsFromDatabase[databaseId]);
  const loadDatasets = useDatastoreStore((s) => s.loadDatasets);

  useEffectOnce(() => {
    loadDatasets(databaseId);
  });

  return { res: datasets, loading: isLoading && !datasets?.length };
};
